(function() {
  var forcedMode = String(window.__UM_CART_MODE_OVERRIDE__ || '').toLowerCase();
  if (forcedMode === 'legacy') {
    return;
  }
  if (document && document.documentElement && document.documentElement.classList && document.documentElement.classList.contains('legacy-cart-mode')) {
    return;
  }
  if (!window.theme || !theme.settings || theme.settings.cartBundleExperiment !== true) {
    return;
  }

  var EXPERIMENT_NAMESPACE = 'um-cart-bundle-experiment';
  var hasPatched = false;
  var ADDON_PARENT_PROPERTY_STRIP_RULES = {
    'customisation-pop-art-text': [
      'Pop Art Text?',
      'Pop Art Words',
      'Pop Art Colour',
      'Pick Pop Art Font?',
      'Pop Art Font'
    ],
    'map-personalisation': [
      'Personalisation?',
      'Personalisation'
    ],
    'fine-art-personalisation': [
      'Personalisation?',
      'Personalisation'
    ],
    'map-customisation-aged': [
      'Colour tone',
      'Aged Level'
    ],
    'customisation-hypsometric-3d': [
      'Map style',
      'Map Style'
    ],
    'map-hanger-frameless-old-map-add-on-item': [
      'Add a map hanger?',
      'Add a hanger?',
      'Hanger colour',
      'Hanger color'
    ]
  };

  function logWarn() {
    if (!window.console || !console.warn) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[UM Cart Bundle Experiment]');
    console.warn.apply(console, args);
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/&/g, ' and ')
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }
  function escapeSelectorValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }
    return String(value).replace(/"/g, '\\"');
  }

  function getMidDotSeparator() {
    return ' ' + String.fromCharCode(183) + ' ';
  }

  function isLegacyModeActive() {
    var mode = String(window.__UM_CART_MODE_OVERRIDE__ || '').toLowerCase();
    if (mode === 'legacy') return true;
    return !!(document && document.documentElement && document.documentElement.classList && document.documentElement.classList.contains('legacy-cart-mode'));
  }

  function parseJsonSafe(raw, fallback) {
    try {
      return JSON.parse(raw);
    } catch (error) {
      return fallback;
    }
  }

  function readAddonConfig() {
    var el = document.getElementById('um-addon-config-json');
    if (!el) return {};

    try {
      return JSON.parse(el.textContent || '{}');
    } catch (error) {
      logWarn('Invalid addon config JSON. Falling back to legacy cart behavior.', error);
      return {};
    }
  }

  function normalizeAddonConfig(rawConfig) {
    var source = rawConfig && rawConfig.options ? rawConfig.options : rawConfig;
    var normalized = {};

    if (!source || typeof source !== 'object') {
      return normalized;
    }

    Object.keys(source).forEach(function(rawPropertyKey) {
      var optionMap = source[rawPropertyKey];
      if (!optionMap || typeof optionMap !== 'object') return;

      var propertyKey = handleize(rawPropertyKey);
      if (!propertyKey) return;

      normalized[propertyKey] = normalized[propertyKey] || {};

      Object.keys(optionMap).forEach(function(rawOptionKey) {
        var entry = optionMap[rawOptionKey];
        if (!entry || typeof entry !== 'object') return;

        var productHandle = handleize(entry.productHandle || entry.handle || '');
        var productId = entry.productId != null ? String(entry.productId) : '';
        if (!productHandle && !productId) return;

        var optionKey = handleize(rawOptionKey);
        if (!optionKey) return;

        normalized[propertyKey][optionKey] = {
          key: optionKey,
          label: String(entry.label || rawPropertyKey || '').trim(),
          productHandle: productHandle,
          productId: productId,
          alternateProductHandles: Array.isArray(entry.alternateProductHandles)
            ? entry.alternateProductHandles.map(function(handle) { return handleize(handle); }).filter(Boolean)
            : []
        };
      });
    });

    return normalized;
  }

  function buildAddonSignatureIndex(mapping) {
    var handleSet = new Set();
    var idSet = new Set();

    Object.keys(mapping).forEach(function(propertyKey) {
      var values = mapping[propertyKey];
      Object.keys(values || {}).forEach(function(optionKey) {
        var entry = values[optionKey];
        if (!entry) return;
        if (entry.productHandle) handleSet.add(entry.productHandle);
        (entry.alternateProductHandles || []).forEach(function(handle) {
          if (handle) handleSet.add(handle);
        });
        if (entry.productId) idSet.add(String(entry.productId));
      });
    });

    return {
      handles: handleSet,
      ids: idSet
    };
  }

  function getItemProperty(item, keyList) {
    if (!item || !item.properties) return '';
    for (var i = 0; i < keyList.length; i += 1) {
      var value = item.properties[keyList[i]];
      if (value !== undefined && value !== null && String(value).trim() !== '') {
        return String(value).trim();
      }
    }
    return '';
  }

  function getSafeHttpUrl(rawValue) {
    var value = String(rawValue || '').trim();
    if (!value) return '';
    try {
      var parsed = new URL(value, window.location.origin);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return '';
      return parsed.href;
    } catch (error) {
      return '';
    }
  }

  function normalizeProperties(rawProperties) {
    if (!rawProperties) return {};
    if (!Array.isArray(rawProperties) && typeof rawProperties === 'object') return rawProperties;

    if (Array.isArray(rawProperties)) {
      var obj = {};
      rawProperties.forEach(function(entry) {
        if (Array.isArray(entry) && entry.length >= 2) {
          obj[String(entry[0])] = entry[1];
          return;
        }

        if (entry && typeof entry === 'object') {
          if (entry.first !== undefined && entry.last !== undefined) {
            obj[String(entry.first)] = entry.last;
            return;
          }
          if (entry.name !== undefined && entry.value !== undefined) {
            obj[String(entry.name)] = entry.value;
          }
        }
      });
      return obj;
    }

    return {};
  }

  function cloneProperties(properties) {
    var source = normalizeProperties(properties);
    var out = {};
    Object.keys(source || {}).forEach(function(key) {
      out[key] = source[key];
    });
    return out;
  }

  function stripKeysFromProperties(properties, keysToStrip) {
    var next = cloneProperties(properties);
    var changed = false;
    (keysToStrip || []).forEach(function(key) {
      if (Object.prototype.hasOwnProperty.call(next, key)) {
        delete next[key];
        changed = true;
      }
    });
    return {
      properties: next,
      changed: changed
    };
  }

  function requestCartChange(payload) {
    return fetch(getShopifyRoot() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload || {})
    }).then(function(response) {
      if (!response.ok) throw new Error('cart/change failed: ' + response.status);
      return response.json();
    });
  }

  function emitNestedStatus(status, meta) {
    try {
      document.dispatchEvent(new CustomEvent('um:nested-atc-result', {
        detail: Object.assign({ status: status }, meta || {})
      }));
    } catch (error) {
      // no-op: telemetry must never block cart behavior
    }
  }

  function maybeStripParentPropertiesForRemovedAddon(cart, parentKey, addonHandle) {
    var normalizedAddonHandle = handleize(addonHandle || '');
    var keysToStrip = ADDON_PARENT_PROPERTY_STRIP_RULES[normalizedAddonHandle];
    if (!Array.isArray(keysToStrip) || !keysToStrip.length) {
      emitNestedStatus('parent_props_cleanup_skipped_unmapped_addon', {
        addonHandle: normalizedAddonHandle || '',
        parentKey: String(parentKey || '')
      });
      return Promise.resolve(cart || {});
    }

    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var parentItem = null;
    for (var i = 0; i < items.length; i += 1) {
      if (String(items[i] && items[i].key || '') === String(parentKey || '')) {
        parentItem = items[i];
        break;
      }
    }
    if (!parentItem) {
      emitNestedStatus('parent_props_cleanup_parent_not_found', {
        addonHandle: normalizedAddonHandle,
        parentKey: String(parentKey || '')
      });
      return Promise.resolve(cart || {});
    }

    var stripped = stripKeysFromProperties(parentItem.properties, keysToStrip);
    if (!stripped.changed) {
      emitNestedStatus('parent_props_cleanup_noop', {
        addonHandle: normalizedAddonHandle,
        parentKey: String(parentItem.key || ''),
        attemptedKeys: keysToStrip
      });
      return Promise.resolve(cart || {});
    }

    var qty = Number(parentItem.quantity);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;

    return requestCartChange({
      id: parentItem.key,
      quantity: qty,
      properties: stripped.properties
    }).then(function(updatedCart) {
      emitNestedStatus('parent_props_cleanup_applied', {
        addonHandle: normalizedAddonHandle,
        parentKey: String(parentItem.key || ''),
        strippedKeys: keysToStrip
      });
      return updatedCart;
    }).catch(function(error) {
      logWarn('Parent property cleanup failed after add-on remove.', error);
      emitNestedStatus('parent_props_cleanup_failed', {
        addonHandle: normalizedAddonHandle,
        parentKey: String(parentItem && parentItem.key || ''),
        message: error && error.message ? String(error.message) : 'unknown'
      });
      return cart || {};
    });
  }

  function resolveExpectedAddonEntries(item, mapping) {
    var expected = [];
    if (!item || !item.properties) return expected;

    Object.keys(item.properties).forEach(function(rawPropertyKey) {
      var rawValue = item.properties[rawPropertyKey];
      if (rawValue == null || String(rawValue).trim() === '') return;
      if (String(rawPropertyKey).charAt(0) === '_') return;

      var propertyHandle = handleize(rawPropertyKey);
      var optionMap = mapping[propertyHandle];
      if (!optionMap) return;

      var valueHandle = handleize(rawValue);
      var entry = optionMap[valueHandle];
      if (!entry && (valueHandle === 'yes' || valueHandle === 'true' || valueHandle === '1')) {
        entry = optionMap.yes;
      }
      if (!entry) return;

      expected.push(entry);
    });

    return expected;
  }

  function findMatchIndex(expected, childItem, usedIndexes) {
    var childHandle = handleize(childItem && childItem.handle ? childItem.handle : '');
    var childProductId = childItem && childItem.product_id != null ? String(childItem.product_id) : '';

    for (var i = 0; i < expected.length; i += 1) {
      if (usedIndexes.has(i)) continue;
      var entry = expected[i];
      if (!entry) continue;

      if (entry.productHandle && childHandle && entry.productHandle === childHandle) {
        return i;
      }

      if (Array.isArray(entry.alternateProductHandles) && entry.alternateProductHandles.indexOf(childHandle) !== -1) {
        return i;
      }

      if (entry.productId && childProductId && String(entry.productId) === childProductId) {
        return i;
      }
    }

    return -1;
  }

  function findAddonEntryForChildItem(mapping, childItem) {
    if (!mapping || !childItem) return null;
    var childHandle = handleize(childItem.handle || '');
    var childProductId = childItem.product_id != null ? String(childItem.product_id) : '';

    var propertyKeys = Object.keys(mapping);
    for (var i = 0; i < propertyKeys.length; i += 1) {
      var optionMap = mapping[propertyKeys[i]] || {};
      var optionKeys = Object.keys(optionMap);
      for (var j = 0; j < optionKeys.length; j += 1) {
        var entry = optionMap[optionKeys[j]];
        if (!entry) continue;
        if (entry.productHandle && childHandle && entry.productHandle === childHandle) return entry;
        if (Array.isArray(entry.alternateProductHandles) && entry.alternateProductHandles.indexOf(childHandle) !== -1) return entry;
        if (entry.productId && childProductId && String(entry.productId) === childProductId) return entry;
      }
    }

    return null;
  }

  function buildBundleState(cart, mapping, signatureIndex) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    var state = {
      cart: cart || { items: [] },
      parentByChild: {},
      childrenByParent: {},
      childAddonEntryByKey: {},
      orphanKeys: [],
      parentCount: 0,
      explicitLinkDetected: false
    };

    function isAddonCandidate(item) {
      var handle = handleize(item && item.handle ? item.handle : '');
      var productId = item && item.product_id != null ? String(item.product_id) : '';
      return signatureIndex.handles.has(handle) || signatureIndex.ids.has(productId);
    }

    function hasExplicitChildLink(item) {
      if (!item) return false;
      item.properties = normalizeProperties(item.properties);
      return !!(
        getItemProperty(item, ['_um_parent_bundle_token']) ||
        getItemProperty(item, ['_um_bundle_parent_token']) ||
        getItemProperty(item, ['_um_parent_token']) ||
        getItemProperty(item, ['_io_parent_order_group'])
      );
    }

    var explicitParentKeyByToken = {};
    var explicitParentKeyByIoOrderGroup = {};
    items.forEach(function(item) {
      if (isAddonCandidate(item)) return;
      item.properties = normalizeProperties(item.properties);
      var parentToken = getItemProperty(item, ['_um_bundle_token', '_um_bundle_parent_token']);
      if (parentToken) {
        explicitParentKeyByToken[parentToken] = item.key;
        state.explicitLinkDetected = true;
      }

      var ioOrderGroup = getItemProperty(item, ['_io_order_group']);
      if (ioOrderGroup) {
        explicitParentKeyByIoOrderGroup[ioOrderGroup] = item.key;
        state.explicitLinkDetected = true;
      }
    });

    items.forEach(function(item) {
      if (!isAddonCandidate(item)) return;
      item.properties = normalizeProperties(item.properties);

      var parentToken = getItemProperty(item, ['_um_parent_bundle_token', '_um_bundle_parent_token', '_um_parent_token']);
      if (!parentToken) return;
      state.explicitLinkDetected = true;
      var parentKey = explicitParentKeyByToken[parentToken];
      if (!parentKey) return;
      state.parentByChild[item.key] = parentKey;
      state.childrenByParent[parentKey] = state.childrenByParent[parentKey] || [];
      state.childrenByParent[parentKey].push(item.key);
      state.childAddonEntryByKey[item.key] = findAddonEntryForChildItem(mapping, item);
    });

    items.forEach(function(item) {
      if (!isAddonCandidate(item)) return;
      if (state.parentByChild[item.key]) return;
      item.properties = normalizeProperties(item.properties);

      var ioParentOrderGroup = getItemProperty(item, ['_io_parent_order_group']);
      if (!ioParentOrderGroup) return;
      state.explicitLinkDetected = true;

      var parentKey = explicitParentKeyByIoOrderGroup[ioParentOrderGroup];
      if (!parentKey) return;

      state.parentByChild[item.key] = parentKey;
      state.childrenByParent[parentKey] = state.childrenByParent[parentKey] || [];
      state.childrenByParent[parentKey].push(item.key);
      state.childAddonEntryByKey[item.key] = findAddonEntryForChildItem(mapping, item);
    });

    for (var i = 0; i < items.length; i += 1) {
      var parentItem = items[i];
      if (isAddonCandidate(parentItem)) continue;

      var parentKey = parentItem.key;
      var expected = resolveExpectedAddonEntries(parentItem, mapping);
      if (!expected.length) continue;

      var usedExpected = new Set();
      for (var j = i + 1; j < items.length; j += 1) {
        var childItem = items[j];
        if (!isAddonCandidate(childItem)) break;
        if (state.parentByChild[childItem.key]) continue;
        if (hasExplicitChildLink(childItem)) continue;

        var matchIndex = findMatchIndex(expected, childItem, usedExpected);
        if (matchIndex === -1) break;

        usedExpected.add(matchIndex);
        state.parentByChild[childItem.key] = parentKey;
        state.childrenByParent[parentKey] = state.childrenByParent[parentKey] || [];
        state.childrenByParent[parentKey].push(childItem.key);
        state.childAddonEntryByKey[childItem.key] = expected[matchIndex];
      }
    }

    items.forEach(function(item) {
      if (isAddonCandidate(item) && !state.parentByChild[item.key]) {
        state.orphanKeys.push(item.key);
      }
    });

    items.forEach(function(item) {
      if (state.parentByChild[item.key]) return;
      state.parentCount += Number(item.quantity || 0);
    });

    return state;
  }

  function cleanupExperimentMarkup(form) {
    if (!form || !form.products) return;

    form.products.querySelectorAll('.um-cart-addon-list').forEach(function(node) {
      node.remove();
    });

    form.products.querySelectorAll('.um-cart-summary-lines').forEach(function(node) {
      node.remove();
    });

    form.products.querySelectorAll('.um-cart-combined-pricing').forEach(function(node) {
      node.remove();
    });

    form.products.querySelectorAll('.um-cart-legacy-price').forEach(function(node) {
      node.classList.remove('um-cart-legacy-price');
      node.style.display = '';
    });

    form.products.querySelectorAll('.um-cart-summary-hidden').forEach(function(node) {
      node.classList.remove('um-cart-summary-hidden');
      node.style.display = '';
    });

    form.products.querySelectorAll('.um-cart-item--child').forEach(function(node) {
      node.classList.remove('um-cart-item--child');
      node.style.display = '';
    });

    form.products.querySelectorAll('.um-cart-first-visible').forEach(function(node) {
      node.classList.remove('um-cart-first-visible');
    });
  }

  function markFirstVisibleCartRow(form) {
    if (!form || !form.products) return;
    var rows = Array.from(form.products.querySelectorAll('.cart__item'));
    rows.forEach(function(row) { row.classList.remove('um-cart-first-visible'); });
    var firstVisible = rows.find(function(row) {
      return !!(row && row.style && row.style.display !== 'none');
    });
    if (firstVisible) {
      firstVisible.classList.add('um-cart-first-visible');
    }
  }

  function applyExperimentMarkup(form, state) {
    if (!form || !form.products || !state) return;
    cleanupExperimentMarkup(form);

    var itemByKey = {};
    (state.cart.items || []).forEach(function(item) {
      itemByKey[item.key] = item;
    });

    // Hide child rows first.
    Object.keys(state.parentByChild || {}).forEach(function(childKey) {
      var childNode = form.products.querySelector('.cart__item[data-key="' + escapeSelectorValue(childKey) + '"]');
      if (!childNode) return;
      childNode.classList.add('um-cart-item--child');
      childNode.style.display = 'none';
    });

    markFirstVisibleCartRow(form);

    var groupParentKeys = Object.keys(itemByKey).filter(function(key) {
      return !state.parentByChild[key];
    });
    var groupCount = groupParentKeys.length;

    // Apply streamlined summary/pricing to every visible parent row, whether it has
    // add-ons or not, so UI stays consistent across mixed carts.
    Object.keys(itemByKey).forEach(function(parentKey) {
      if (state.parentByChild[parentKey]) return;

      var childKeys = state.childrenByParent[parentKey] || [];
      var parentItem = itemByKey[parentKey];

      var parentNode = form.products.querySelector('.cart__item[data-key="' + escapeSelectorValue(parentKey) + '"]');
      if (!parentNode) return;
      var childEntries = [];

      childKeys.forEach(function(childKey) {
        var childNode = form.products.querySelector('.cart__item[data-key="' + escapeSelectorValue(childKey) + '"]');
        var childItem = itemByKey[childKey];
        if (!childItem || !childNode) return;

        childNode.classList.add('um-cart-item--child');
        childNode.style.display = 'none';

        var entry = state.childAddonEntryByKey[childKey];
        var label = getAddonDisplayLabel(entry, childItem, parentItem);
        childEntries.push({
          key: childKey,
          label: label,
          item: childItem,
          node: childNode,
          entry: entry
        });
      });

      applyCombinedSummary(parentNode, parentItem, childEntries, form);
      applyCombinedPricing(parentNode, parentItem, childEntries, form, groupCount);
    });

    applyCartSavingsLabel(form, groupCount, state.cart);
    markFirstVisibleCartRow(form);
  }

  function getSingleActiveDiscountTitle(form, cart) {
    var titlesByKey = {};

    function addTitle(value) {
      var title = String(value || '').trim();
      if (!title) return;
      var key = title.toLowerCase();
      if (!titlesByKey[key]) titlesByKey[key] = title;
    }

    ((cart && cart.items) || []).forEach(function(item) {
      (item.discount_titles || []).forEach(addTitle);
      (item.line_level_discount_allocations || []).forEach(function(allocation) {
        addTitle(allocation && allocation.discount_application && allocation.discount_application.title);
      });
    });

    if (form && form.form) {
      form.form.querySelectorAll('[data-cart-discount-title]').forEach(function(node) {
        addTitle(node.getAttribute('data-cart-discount-title'));
      });
    }

    var titles = Object.keys(titlesByKey).map(function(key) {
      return titlesByKey[key];
    });
    return titles.length === 1 ? titles[0] : '';
  }

  function applyCartSavingsLabel(form, groupCount, cart) {
    if (!form || !form.form) return;
    var discountsRoot = form.form.querySelector('[data-discounts]');
    if (!discountsRoot) return;
    var labelNode = discountsRoot.querySelector('.cart__discounts > div');
    if (!labelNode) return;

    var strings = window.theme && theme.strings ? theme.strings : {};
    var singleLabel = strings.cartYouSavedLabel || 'You saved';
    var totalLabel = strings.cartTotalSavingsLabel || 'Total savings';
    var label = groupCount > 1 ? totalLabel : singleLabel;
    var discountTitle = getSingleActiveDiscountTitle(form, cart);
    labelNode.textContent = discountTitle ? label + ' (' + discountTitle + ')' : label;
  }

  function getAddonDisplayLabel(entry, childItem, parentItem) {
    var baseLabel = (entry && entry.label) ? entry.label : (childItem && (childItem.product_title || childItem.title) ? (childItem.product_title || childItem.title) : 'Add-on');
    var childHandle = handleize(childItem && childItem.handle ? childItem.handle : '');

    var mappedHandle = handleize(entry && entry.productHandle ? entry.productHandle : '');

    if (childHandle === 'map-customisation-aged' || mappedHandle === 'map-customisation-aged') {
      var agedLevel = getItemProperty(parentItem, ['Aged Level']);
      if (agedLevel) return 'Colour tone: Aged (' + agedLevel + ')';
      return 'Colour tone: Aged';
    }

    if (childHandle === 'customisation-hypsometric-3d' || mappedHandle === 'customisation-hypsometric-3d') {
      return 'Hypsometric 3D style';
    }

    if (
      childHandle === 'customisation-unique-3d' ||
      childHandle === 'customisation-unique-3d-pm' ||
      mappedHandle === 'customisation-unique-3d' ||
      mappedHandle === 'customisation-unique-3d-pm'
    ) {
      var parentUnique3dValue = handleize(getItemProperty(parentItem, ['Unique 3D?']));
      var parentUnique3dPmValue = handleize(getItemProperty(parentItem, ['Unique 3D PM']));
      if (
        parentUnique3dValue === 'yes' || parentUnique3dValue === 'true' || parentUnique3dValue === '1' ||
        parentUnique3dPmValue === 'yes' || parentUnique3dPmValue === 'true' || parentUnique3dPmValue === '1'
      ) {
        return 'Unique 3D';
      }
    }

    if (childHandle === 'customisation-artist-border' || mappedHandle === 'customisation-artist-border') {
      return 'Artist border';
    }

    if (childHandle === 'customisation-pop-art-text' || mappedHandle === 'customisation-pop-art-text') {
      var popArtWords = getItemProperty(parentItem, ['Pop Art Words']);
      if (popArtWords) {
        return 'Pop art text: ' + popArtWords;
      }
      return 'Pop art text';
    }

    return baseLabel;
  }

  function hideForSummary(node) {
    if (!node) return;
    node.classList.add('um-cart-summary-hidden');
    node.style.display = 'none';
  }

  function getVariantValueFromNode(parentNode, keyName) {
    if (!parentNode || !keyName) return '';
    var normalizedKey = String(keyName).trim().toLowerCase();
    var variantRows = parentNode.querySelectorAll('.cart__item--variants > div');
    var rowValues = [];
    for (var i = 0; i < variantRows.length; i += 1) {
      var row = variantRows[i];
      var labelEl = row.querySelector('span');
      if (!labelEl) continue;
      var label = String(labelEl.textContent || '').replace(':', '').trim().toLowerCase();
      if (label !== normalizedKey) continue;
      var value = String(row.textContent || '').replace(String(labelEl.textContent || ''), '').trim();
      return value;
    }

    // Translation apps can rewrite "Size"/"Finish" labels, so fall back by row position.
    for (var j = 0; j < variantRows.length; j += 1) {
      var fallbackRow = variantRows[j];
      var fallbackLabelEl = fallbackRow.querySelector('span');
      if (!fallbackLabelEl) continue;
      var fallbackValue = String(fallbackRow.textContent || '').replace(String(fallbackLabelEl.textContent || ''), '').trim();
      if (fallbackValue) rowValues.push(fallbackValue);
    }

    if (normalizedKey === 'size' && rowValues.length > 0) return rowValues[0];
    if (normalizedKey === 'finish' && rowValues.length > 1) return rowValues[1];

    return '';
  }

  function normalizeDisplaySize(sizeValue, preserveQualifier) {
    var value = String(sizeValue || '').trim();
    if (!value) return '';
    if (preserveQualifier) return value.replace(/\s*-\s*/g, ' ').trim();
    if (value.indexOf(' - ') !== -1) {
      return value.split(' - ').pop().trim();
    }
    return value;
  }

  function splitDisplaySizeParts(sizeValue) {
    var value = String(sizeValue || '').trim();
    if (!value) return { qualifier: '', dimensions: '' };

    var match = value.match(/^(.+?)\s*-\s*(.+)$/);
    if (!match) {
      return {
        qualifier: '',
        dimensions: normalizeDisplaySize(value, false)
      };
    }

    return {
      qualifier: String(match[1] || '').trim(),
      dimensions: normalizeDisplaySize(String(match[2] || '').trim(), false)
    };
  }

  function getAddonSummaryToken(entry, parentItem) {
    var handle = handleize(entry && entry.productHandle ? entry.productHandle : '');
    var label = String(entry && entry.label ? entry.label : '').trim();

    if (handle === 'map-customisation-aged') {
      var agedLevel = getItemProperty(parentItem, ['Aged Level']);
      var agedToneLabel = getCartString('cartAgedToneLabel', 'Aged tone');
      return agedLevel ? (agedToneLabel + ' ' + agedLevel) : agedToneLabel;
    }
    if (handle === 'customisation-hypsometric-3d') return 'Hypsometric 3D style';
    if (handle === 'map-personalisation' || handle === 'fine-art-personalisation') return 'Personalised';
    if (handle === 'customisation-unique-3d' || handle === 'customisation-unique-3d-pm') return 'Unique 3D';
    if (handle === 'customisation-artist-border') return 'Artist border';
    if (handle === 'customisation-pop-art-text') return 'Pop art text';
    if (handle === 'map-hanger-frameless-old-map-add-on-item') {
      var hangerColour = getItemProperty(parentItem, ['Hanger colour', 'Hanger color']);
      if (hangerColour) return 'Wooden hanger\u00A0' + formatBracketColour(hangerColour);
      return 'Wooden hanger';
    }

    if (!label) return '';
    return label.replace(/^Customisation\s*\((.*)\)$/i, '$1').trim();
  }

  function buildAddonTokenHtml(row, tokenText) {
    var token = String(tokenText || '').trim();
    if (!token) return '';

    var addonHandle = handleize(row && row.addonHandle ? row.addonHandle : '');
    if (addonHandle === 'map-customisation-aged') {
      var agedToneMatch = token.match(/\b(Subtle|Balanced|Rich)\b/i);
      if (agedToneMatch) {
        return '<strong class="um-cart-summary-token-main">Aged</strong>' +
          '<span class="um-cart-summary-sep">' + escapeHtml(getMidDotSeparator()) + '</span>' +
          '<span class="um-cart-summary-token-tail">' + escapeHtml(agedToneMatch[1]) + '</span>';
      }
      var agedLevelMatch = token.match(/(\d{1,3}%)/);
      if (agedLevelMatch) {
        return '<strong class="um-cart-summary-token-main">Aged</strong>' +
          '<span class="um-cart-summary-sep">' + escapeHtml(getMidDotSeparator()) + '</span>' +
          '<span class="um-cart-summary-token-tail">' + escapeHtml(agedLevelMatch[1]) + '</span>';
      }
      return '<strong class="um-cart-summary-token-main">Aged</strong>';
    }

    return '<strong class="um-cart-summary-token-main">' + escapeHtml(token) + '</strong>';
  }

  function buildAddonRemoveButtonHtml(row, tokenText) {
    if (!row || !row.childKey) return '';
    var addonHandle = handleize(row.addonHandle || '');
    if (addonHandle === 'customisation-hypsometric-3d') return '';
    var escaped = escapeHtml(String(tokenText || '').trim());
    return '<button type="button" class="um-cart-linked-remove" data-child-key="' + escapeHtml(row.childKey) + '" data-parent-key="' + escapeHtml(row.parentKey || '') + '" data-addon-handle="' + escapeHtml(row.addonHandle || '') + '" aria-label="Remove ' + escaped + ' from basket">remove</button>';
  }

  function getDesktopAddonSummaryLabel(row) {
    var addonHandle = handleize(row && row.addonHandle ? row.addonHandle : '');
    if (addonHandle === 'map-customisation-aged') return 'Colour tone';
    if (addonHandle === 'map-hanger-frameless-old-map-add-on-item') return 'Hanger';
    if (addonHandle === 'customisation-hypsometric-3d') return 'Map style';
    if (addonHandle === 'customisation-unique-3d' || addonHandle === 'customisation-unique-3d-pm') return 'Map style';
    if (addonHandle === 'customisation-pop-art-text') return 'Personalisation';
    if (addonHandle === 'map-personalisation' || addonHandle === 'fine-art-personalisation') return 'Personalisation';
    if (addonHandle === 'customisation-artist-border') return 'Artist border';
    if (addonHandle === 'limited-edition') return 'Edition';
    return 'Add-on';
  }

  function shouldUseDesktopAddonPrefix(row) {
    var addonHandle = handleize(row && row.addonHandle ? row.addonHandle : '');
    return addonHandle === 'map-customisation-aged';
  }

  function buildDesktopAddonStandaloneHtml(row, tokenText) {
    var addonHandle = handleize(row && row.addonHandle ? row.addonHandle : '');
    if (addonHandle === 'map-personalisation' || addonHandle === 'fine-art-personalisation') {
      return '<strong class="um-cart-summary-token-main">Personalisation</strong>';
    }
    return buildDesktopAddonValueHtml(row, tokenText);
  }

  function buildDesktopAddonValueHtml(row, tokenText) {
    var token = String(tokenText || '').trim();
    if (!token) return '';

    var addonHandle = handleize(row && row.addonHandle ? row.addonHandle : '');
    if (addonHandle === 'map-customisation-aged') {
      var agedToneMatch = token.match(/\b(Subtle|Balanced|Rich)\b/i);
      if (agedToneMatch) {
        return '<span class="um-cart-summary-token-plain">Aged' + escapeHtml(getMidDotSeparator()) + escapeHtml(agedToneMatch[1]) + '</span>';
      }
      var agedLevelMatch = token.match(/(\d{1,3}%)/);
      if (agedLevelMatch) {
        return '<span class="um-cart-summary-token-plain">Aged' + escapeHtml(getMidDotSeparator()) + escapeHtml(agedLevelMatch[1]) + '</span>';
      }
      return '<span class="um-cart-summary-token-plain">Aged</span>';
    }

    return buildAddonTokenHtml(row, tokenText);
  }

  function buildAddonDetailSubrowsHtml(detailRows, className) {
    if (!Array.isArray(detailRows) || !detailRows.length) return '';
    var rowClass = className ? String(className) : 'um-cart-summary-link-subrow';
    return detailRows.map(function(row) {
      var label = String(row && row.label ? row.label : '').trim();
      var value = String(row && row.value ? row.value : '').trim();
      if (!label || !value) return '';
      return '<div class="' + escapeHtml(rowClass) + '"><span class="um-cart-summary-subrow-label">' + escapeHtml(label) + ':</span> <span class="um-cart-summary-subrow-value">' + escapeHtml(value) + '</span></div>';
    }).join('');
  }

  function formatBracketColour(colourValue) {
    var colour = String(colourValue || '').trim();
    if (!colour) return '';
    return '(' + colour.replace(/\s+/g, '\u00A0') + ')';
  }

  function hasAddonHandle(childEntries, handleList) {
    var normalizedHandles = (handleList || []).map(function(handle) { return handleize(handle); });
    return (childEntries || []).some(function(childEntry) {
      var entryHandle = handleize(childEntry && childEntry.entry && childEntry.entry.productHandle ? childEntry.entry.productHandle : '');
      return normalizedHandles.indexOf(entryHandle) !== -1;
    });
  }

  function buildAddonContentRows(parentItem, childEntries) {
    var rows = [];

    var hasPersonalisationAddon =
      hasAddonHandle(childEntries, ['map-personalisation', 'fine-art-personalisation']) ||
      (function() {
        var v = handleize(getItemProperty(parentItem, ['Personalisation?']));
        return v === 'yes' || v === 'true' || v === '1';
      })();

    if (hasPersonalisationAddon) {
      var editSavedDesignUrl = getSafeHttpUrl(getItemProperty(parentItem, ['_Edit Link', 'Edit Link']));
      if (editSavedDesignUrl) {
        rows.push({
          label: 'Mark your map',
          value: 'Edit saved design',
          href: editSavedDesignUrl
        });
      }
    }

    var hasPopArtAddon =
      hasAddonHandle(childEntries, ['customisation-pop-art-text']) ||
      (function() {
        var v = handleize(getItemProperty(parentItem, ['Pop Art Text?']));
        return v === 'yes' || v === 'true' || v === '1';
      })();
    var hasPopArtAddonLine = hasAddonHandle(childEntries, ['customisation-pop-art-text']);

    if (hasPopArtAddon && !hasPopArtAddonLine) {
      var popArtWords = getItemProperty(parentItem, ['Pop Art Words']);
      if (popArtWords) {
        rows.push({
          label: 'Pop art text',
          value: popArtWords
        });
      }

      var popArtColour = getItemProperty(parentItem, ['Pop Art Colour', 'Pop Art Color']);
      if (popArtColour) {
        rows.push({
          label: 'Pop art colour',
          value: popArtColour
        });
      }

      var pickPopArtFont = handleize(getItemProperty(parentItem, ['Pick Pop Art Font?']));
      var hasCustomPopArtFont =
        pickPopArtFont === 'yes' ||
        pickPopArtFont === 'true' ||
        pickPopArtFont === '1';
      var popArtFont = getItemProperty(parentItem, ['Pop Art Font']);
      if (popArtFont && (hasCustomPopArtFont || pickPopArtFont === '')) {
        rows.push({
          label: 'Pop art font',
          value: popArtFont
        });
      }
    }

    return rows;
  }

  function applyCombinedSummary(parentNode, parentItem, childEntries, form) {
    if (!parentNode || !parentItem) return;
    var titleNode = parentNode.querySelector('.cart__item-title');
    if (!titleNode) return;

    var displaySizeValue = getItemProperty(parentItem, ['_Display Size']);
    var sizeFallbackValue = getVariantValueFromNode(parentNode, 'size') || getItemProperty(parentItem, ['Size']);
    var sizeParts = splitDisplaySizeParts(displaySizeValue);
    var sizeQualifier = sizeParts.qualifier;
    var sizeValue = sizeParts.dimensions || normalizeDisplaySize(sizeFallbackValue, false);
    var finishValue = getVariantValueFromNode(parentNode, 'finish');
    var frameColourValue = getItemProperty(parentItem, ['Frame colour', 'Frame color']);
    var limitedEditionRaw = getItemProperty(parentItem, ['Limited Edition']);
    var limitedEditionNorm = handleize(limitedEditionRaw);
    var hasLimitedEdition =
      limitedEditionNorm === 'yes' ||
      limitedEditionNorm === 'true' ||
      limitedEditionNorm === '1' ||
      (limitedEditionRaw && limitedEditionNorm !== 'no');
    var personalisationDetailsText = getItemProperty(parentItem, ['Personalisation', 'Personalisation details']);

    function buildDetailRowsForAddon(addonHandle) {
      var rows = [];
      if (addonHandle === 'map-personalisation' || addonHandle === 'fine-art-personalisation') {
        if (personalisationDetailsText) {
          rows.push({ label: 'Details', value: personalisationDetailsText });
        }
        return rows;
      }
      if (addonHandle === 'customisation-pop-art-text') {
        var popArtTextValue = getItemProperty(parentItem, ['Pop Art Words']);
        if (popArtTextValue) {
          rows.push({ label: 'Text', value: popArtTextValue });
        }
        var popArtColourValue = getItemProperty(parentItem, ['Pop Art Colour', 'Pop Art Color']);
        if (popArtColourValue) {
          rows.push({ label: 'Colour', value: popArtColourValue });
        }
        var pickPopArtFontValue = handleize(getItemProperty(parentItem, ['Pick Pop Art Font?']));
        var hasCustomPopArtFont =
          pickPopArtFontValue === 'yes' ||
          pickPopArtFontValue === 'true' ||
          pickPopArtFontValue === '1';
        var popArtFontValue = getItemProperty(parentItem, ['Pop Art Font']);
        if (popArtFontValue && (hasCustomPopArtFont || pickPopArtFontValue === '')) {
          rows.push({ label: 'Font', value: popArtFontValue });
        }
      }
      return rows;
    }

    var baseParts = [];
    if (sizeQualifier) baseParts.push(sizeQualifier);
    if (sizeValue) baseParts.push(sizeValue);

    var addOnRows = [];
    var seen = {};
    if (sizeQualifier) {
      var qualifierToken = sizeQualifier;
      var qualifierKey = handleize(qualifierToken);
      seen[qualifierKey] = true;
    }
    if (hasLimitedEdition) {
      seen['limited-edition'] = true;
      addOnRows.push({ token: 'Limited Edition', childKey: '', priceHtml: '' });
    }
    (childEntries || []).forEach(function(childEntry) {
      var token = getAddonSummaryToken(childEntry && childEntry.entry ? childEntry.entry : null, parentItem);
      if (!token) return;
      var dedupeKey = handleize(token);
      if (seen[dedupeKey]) return;
      seen[dedupeKey] = true;
      var childKey = childEntry && childEntry.key ? String(childEntry.key) : '';
      var childLineItem = childEntry && childEntry.item ? childEntry.item : null;
      var addonHandle = handleize(
        (childEntry && childEntry.entry && childEntry.entry.productHandle) ||
        (childLineItem && childLineItem.handle) ||
        ''
      );
      var childPriceMeta = getLinePriceMeta(childLineItem || {});
      var priceHtml = '';
      if (addonHandle !== 'map-customisation-aged' && childPriceMeta && Number.isFinite(childPriceMeta.finalCents)) {
        if (childPriceMeta.savingsCents > 0 && childPriceMeta.regularCents > childPriceMeta.finalCents) {
          priceHtml = '<small class="um-cart-addon-compare">' + renderMoney(form, childPriceMeta.regularCents) + '</small><span class="um-cart-addon-sale">' + renderMoney(form, childPriceMeta.finalCents) + '</span>';
        } else {
          priceHtml = '<span class="um-cart-addon-sale">' + renderMoney(form, childPriceMeta.finalCents) + '</span>';
        }
      }
      addOnRows.push({
        token: token,
        childKey: childKey,
        parentKey: parentItem && parentItem.key ? String(parentItem.key) : '',
        addonHandle: addonHandle,
        priceHtml: priceHtml,
        detailRows: buildDetailRowsForAddon(addonHandle)
      });
    });

    var fallbackPersonalisation = handleize(getItemProperty(parentItem, ['Personalisation?']));
    if ((fallbackPersonalisation === 'yes' || fallbackPersonalisation === 'true' || fallbackPersonalisation === '1') && !seen.personalised) {
      seen.personalised = true;
      addOnRows.push({
        token: 'Personalised',
        childKey: '',
        priceHtml: '',
        addonHandle: 'map-personalisation',
        detailRows: buildDetailRowsForAddon('map-personalisation')
      });
    }

    if (!baseParts.length && !addOnRows.length) return;

    var activeAddonHandles = {};
    (childEntries || []).forEach(function(childEntry) {
      var h = handleize(childEntry && childEntry.entry && childEntry.entry.productHandle ? childEntry.entry.productHandle : '');
      if (h) activeAddonHandles[h] = true;
    });

    var variantsNode = parentNode.querySelector('.cart__item--variants');
    if (variantsNode) hideForSummary(variantsNode);

    parentNode.querySelectorAll('.custom_properties').forEach(function(propNode) {
      var strong = propNode.querySelector('strong');
      var label = strong ? String(strong.textContent || '').replace(/:\s*$/, '').trim() : '';
      var value = String(propNode.textContent || '').replace(String(strong ? strong.textContent : ''), '').trim();
      var normalizedLabel = handleize(label);
      var normalizedValue = handleize(value);

      // Frame colour is already surfaced in the compact base summary line.
      if (
        (normalizedLabel === 'frame-colour' || normalizedLabel === 'frame-color') &&
        frameColourValue &&
        normalizedValue === handleize(frameColourValue)
      ) {
        return hideForSummary(propNode);
      }
      if (
        (normalizedLabel === 'hanger-colour' || normalizedLabel === 'hanger-color') &&
        value
      ) {
        return hideForSummary(propNode);
      }

      // Never hide meaningful base customisation text unless it is explicitly shown
      // in our add-on content rows.
      if (normalizedLabel === 'personalisation' || normalizedLabel === 'personalisation-details') {
        var fallbackPersonalisationActive = (function() {
          var v = handleize(getItemProperty(parentItem, ['Personalisation?']));
          return v === 'yes' || v === 'true' || v === '1';
        })();
        var hasAddonPersonalisation = !!(activeAddonHandles['map-personalisation'] || activeAddonHandles['fine-art-personalisation'] || fallbackPersonalisationActive);
        if (!hasAddonPersonalisation) return;
        // Personalisation details are rendered directly under the personalisation add-on line item.
        if (value) return hideForSummary(propNode);
      }

      // Hide only known add-on control/meta lines when corresponding add-on is active.
      if (normalizedLabel === 'colour-tone' && activeAddonHandles['map-customisation-aged']) return hideForSummary(propNode);
      if (normalizedLabel === 'aged-level' && activeAddonHandles['map-customisation-aged']) return hideForSummary(propNode);
      if (normalizedLabel === 'map-style' && activeAddonHandles['customisation-hypsometric-3d']) return hideForSummary(propNode);
      if (normalizedLabel === 'personalisation' && normalizedValue === 'yes' && (activeAddonHandles['map-personalisation'] || activeAddonHandles['fine-art-personalisation'])) return hideForSummary(propNode);
      if (normalizedLabel === 'personalisation' && normalizedValue === 'no' && (activeAddonHandles['map-personalisation'] || activeAddonHandles['fine-art-personalisation'])) return hideForSummary(propNode);
      if (normalizedLabel === 'pop-art-text' && activeAddonHandles['customisation-pop-art-text']) return hideForSummary(propNode);
      if (normalizedLabel === 'pop-art-words' && activeAddonHandles['customisation-pop-art-text']) return hideForSummary(propNode);
      if (normalizedLabel === 'pop-art-colour' && activeAddonHandles['customisation-pop-art-text']) return hideForSummary(propNode);
      if (normalizedLabel === 'pick-pop-art-font' && activeAddonHandles['customisation-pop-art-text']) return hideForSummary(propNode);
      if (normalizedLabel === 'pop-art-font' && activeAddonHandles['customisation-pop-art-text']) return hideForSummary(propNode);
      if ((normalizedLabel === 'unique-3d' || normalizedLabel === 'unique-3d-pm') && (activeAddonHandles['customisation-unique-3d'] || activeAddonHandles['customisation-unique-3d-pm'])) return hideForSummary(propNode);
      if ((normalizedLabel === 'add-artist-border' || normalizedLabel === 'artist-border' || normalizedLabel === 'artist-name') && activeAddonHandles['customisation-artist-border']) return hideForSummary(propNode);
      if (normalizedLabel === 'limited-edition' && hasLimitedEdition) return hideForSummary(propNode);
    });

    var unconnectedRows = [];
    parentNode.querySelectorAll('.custom_properties').forEach(function(propNode) {
      if (!propNode || propNode.classList.contains('um-cart-summary-hidden')) return;
      var strong = propNode.querySelector('strong');
      var label = strong ? String(strong.textContent || '').replace(/:\s*$/, '').trim() : '';
      var value = String(propNode.textContent || '').replace(String(strong ? strong.textContent : ''), '').trim();
      var normalizedLabel = handleize(label);

      if (!label || !value) return;
      if (!normalizedLabel) return;
      if (normalizedLabel.charAt(0) === '_') return;
      if (normalizedLabel === 'edit' || normalizedLabel === 'custom-image' || normalizedLabel === 'map-icon') return;

      unconnectedRows.push({
        label: label,
        value: value
      });
      hideForSummary(propNode);
    });

    var summary = document.createElement('div');
    summary.className = 'um-cart-summary-lines notranslate';
    summary.setAttribute('translate', 'no');
    summary.setAttribute('data-langshop-ignore', 'true');
    var addonContentRows = buildAddonContentRows(parentItem, childEntries);
    var addonContentHtml = '';
    if (addonContentRows.length) {
      addonContentHtml = '<div class="um-cart-addon-content-list">' + addonContentRows.map(function(row) {
        var valueHtml = '<span class="um-cart-kv-value">' + escapeHtml(row.value) + '</span>';
        var href = getSafeHttpUrl(row && row.href ? row.href : '');
        if (href) {
          valueHtml = '<a class="um-cart-kv-link" href="' + escapeHtml(href) + '" target="_blank" rel="noopener">' + escapeHtml(String(row.value || 'Edit saved design')) + '</a>';
        }
        return '<div class="um-cart-addon-content-row"><span class="um-cart-kv-key">' + escapeHtml(row.label) + '</span><span class="um-cart-summary-sep">' + escapeHtml(getMidDotSeparator()) + '</span>' + valueHtml + '</div>';
      }).join('') + '</div>';
    }

    var unconnectedContentHtml = '';
    if (unconnectedRows.length) {
      unconnectedContentHtml = '<div class="um-cart-unconnected-props">' + unconnectedRows.map(function(row) {
        return '<div class="um-cart-unconnected-prop-row"><span class="um-cart-kv-key">' + escapeHtml(row.label) + '</span><span class="um-cart-summary-sep">' + escapeHtml(getMidDotSeparator()) + '</span><span class="um-cart-kv-value">' + escapeHtml(row.value) + '</span></div>';
      }).join('') + '</div>';
    }

    var baseLineHtml = '';

    // Compact/mobile: always split finish onto its own line (no "Finish:" prefix).
    var compactBaseParts = baseParts.slice();
    var compactFinishParts = [];
    if (finishValue) compactFinishParts.push(finishValue);
    if (frameColourValue) compactFinishParts.push(frameColourValue + ' frame');

    if (compactBaseParts.length) {
      baseLineHtml = '<div class="um-cart-summary-line um-cart-summary-line--base">' + escapeHtml(compactBaseParts.join(getMidDotSeparator())) + '</div>';
    }

    var finishLineHtml = '';
    if (compactFinishParts.length) {
      finishLineHtml = '<div class="um-cart-summary-line um-cart-summary-line--base">' + escapeHtml(compactFinishParts.join(getMidDotSeparator())) + '</div>';
    }

    var addOnLineHtml = '';
    if (addOnRows.length) {
      var limitedEditionToken = hasLimitedEdition ? 'Limited Edition' : '';
      var addOnRowsHtml = addOnRows.map(function(row) {
        var tokenText = String(row && row.token ? row.token : '');
        var tokenClass = 'um-cart-summary-token';
        if (limitedEditionToken && tokenText === limitedEditionToken) {
          tokenClass += ' um-cart-summary-token--abbrev';
        }
        var removeButtonHtml = buildAddonRemoveButtonHtml(row, tokenText);
        var priceHtml = row && row.priceHtml ? '<span class="um-cart-summary-link-price">' + row.priceHtml + '</span>' : '<span class="um-cart-summary-link-price"></span>';
        var detailsSubrowHtml = buildAddonDetailSubrowsHtml(row && row.detailRows ? row.detailRows : [], 'um-cart-summary-link-subrow');
        return '<div class="um-cart-summary-link-item">' +
          '<div class="um-cart-summary-link-row">' +
            '<span class="' + tokenClass + '">' + buildAddonTokenHtml(row, tokenText) + '</span>' +
            priceHtml +
            (removeButtonHtml || '<span class="um-cart-summary-link-remove-spacer"></span>') +
          '</div>' +
          detailsSubrowHtml +
        '</div>';
      }).join('');
      addOnLineHtml = '<div class="um-cart-summary-line um-cart-summary-line--addons um-cart-summary-line--linked">' + addOnRowsHtml + '</div>';
    }

    var desktopSummaryRows = [];
    var desktopBaseParts = baseParts.slice();
    var desktopFinishParts = [];
    if (finishValue) desktopFinishParts.push(finishValue);
    if (frameColourValue) desktopFinishParts.push(frameColourValue + ' frame');

    if (desktopBaseParts.length) {
      desktopSummaryRows.push(
        '<div class="um-cart-summary-desktop-row um-cart-summary-desktop-row--size">' +
          '<span class="um-cart-summary-desktop-main">' +
            '<span class="um-cart-summary-desktop-label">Size:</span> ' +
            '<span class="um-cart-summary-desktop-value">' + escapeHtml(desktopBaseParts.join(getMidDotSeparator())) + '</span>' +
          '</span>' +
        '</div>'
      );
    }
    if (desktopFinishParts.length) {
      desktopSummaryRows.push(
        '<div class="um-cart-summary-desktop-row um-cart-summary-desktop-row--finish">' +
          '<span class="um-cart-summary-desktop-main">' +
            '<span class="um-cart-summary-desktop-label">Finish:</span> ' +
            '<span class="um-cart-summary-desktop-value">' + escapeHtml(desktopFinishParts.join(getMidDotSeparator())) + '</span>' +
          '</span>' +
        '</div>'
      );
    }
    if (addOnRows.length) {
      addOnRows.forEach(function(row) {
        var tokenText = String(row && row.token ? row.token : '');
        var removeButtonHtml = buildAddonRemoveButtonHtml(row, tokenText);
        var priceHtml = row && row.priceHtml ? '<span class="um-cart-summary-link-price">' + row.priceHtml + '</span>' : '';
        var actionsHtml = '';
        var addonMainHtml = '';

        if (shouldUseDesktopAddonPrefix(row)) {
          addonMainHtml =
            '<span class="um-cart-summary-desktop-main">' +
              '<span class="um-cart-summary-desktop-label">' + escapeHtml(getDesktopAddonSummaryLabel(row)) + ':</span> ' +
              '<span class="um-cart-summary-desktop-value">' + buildDesktopAddonValueHtml(row, tokenText) + '</span>' +
            '</span>';
        } else {
          addonMainHtml =
            '<span class="um-cart-summary-desktop-main">' +
              '<span class="um-cart-summary-desktop-value">' + buildDesktopAddonStandaloneHtml(row, tokenText) + '</span>' +
            '</span>';
        }

        if (priceHtml || removeButtonHtml) {
          actionsHtml = '<span class="um-cart-summary-desktop-actions">' + priceHtml + removeButtonHtml + '</span>';
        }
        var detailsSubrowHtml = buildAddonDetailSubrowsHtml(row && row.detailRows ? row.detailRows : [], 'um-cart-summary-desktop-subrow');
        desktopSummaryRows.push(
          '<div class="um-cart-summary-desktop-item">' +
            '<div class="um-cart-summary-desktop-row um-cart-summary-desktop-row--addon">' +
              addonMainHtml +
              actionsHtml +
            '</div>' +
            detailsSubrowHtml +
          '</div>'
        );
      });
    }
    var desktopSummaryHtml = desktopSummaryRows.length
      ? '<div class="um-cart-summary-desktop">' + desktopSummaryRows.join('') + '</div>'
      : '';

    summary.innerHTML = [
      '<div class="um-cart-summary-compact">' + [
        baseLineHtml,
        finishLineHtml,
        addOnLineHtml
      ].join('') + '</div>',
      desktopSummaryHtml,
      addonContentHtml,
      unconnectedContentHtml
    ].join('');

    summary.addEventListener('click', function(event) {
      var btn = event.target && event.target.closest ? event.target.closest('.um-cart-linked-remove') : null;
      if (!btn || !summary.contains(btn)) return;
      event.preventDefault();
      event.stopPropagation();
      var childKey = String(btn.getAttribute('data-child-key') || '').trim();
      var parentKey = String(btn.getAttribute('data-parent-key') || '').trim();
      var addonHandle = String(btn.getAttribute('data-addon-handle') || '').trim();
      if (!childKey || !form) return;
      if (btn.disabled) return;
      btn.disabled = true;
      theme.cart.changeItem(childKey, 0)
        .then(function(cart) {
          if (cart && typeof cart === 'object') return cart;
          return theme.cart.getCart();
        })
        .then(function(cart) {
          return maybeStripParentPropertiesForRemovedAddon(cart, parentKey, addonHandle);
        })
        .then(function(cart) {
          var safeCart = cart || {};
          setWrapperEmptyState(form, safeCart);
          form.buildCart();
          dispatchCartUpdated(safeCart);
          document.dispatchEvent(new CustomEvent('cart:build'));
        })
        .catch(function(error) {
          logWarn('Linked add-on remove failed.', error);
          btn.disabled = false;
        });
    });

    titleNode.appendChild(summary);
  }

  function getShopifyRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function getNumericCents(value, fallback) {
    var parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
    return Number.isFinite(fallback) ? fallback : 0;
  }

  function getLinePriceMeta(item) {
    var finalCents = getNumericCents(item && item.final_line_price, 0);
    var originalCents = getNumericCents(item && item.original_line_price, 0);
    var compareCents = getNumericCents(item && item.compare_line_price, 0);
    var hasLineDiscount = (
      Array.isArray(item && item.line_level_discount_allocations) && item.line_level_discount_allocations.length > 0
    ) || (
      Array.isArray(item && item.discount_titles) && item.discount_titles.length > 0
    );

    // Primary source: Shopify cart line pricing (original vs final).
    var regularCandidate = originalCents > 0 ? originalCents : finalCents;

    // Optional fallback: for pure sale rows without discount allocations, allow compare-at
    // data as a display regular price if it is higher.
    if (!hasLineDiscount && compareCents > regularCandidate) {
      regularCandidate = compareCents;
    }

    if (regularCandidate < finalCents) {
      regularCandidate = finalCents;
    }
    var savings = regularCandidate - finalCents;
    if (savings < 0) savings = 0;

    return {
      regularCents: regularCandidate,
      finalCents: finalCents,
      savingsCents: savings
    };
  }

  function renderMoney(form, cents) {
    if (!form || typeof form.formatCartMoney !== 'function') {
      return String(cents || '');
    }
    return String(form.formatCartMoney(cents));
  }

  function getCartString(key, fallback) {
    var strings = window.theme && theme.strings ? theme.strings : {};
    var value = strings[key];
    if (typeof value === 'string' && value.trim() !== '') return value;
    return fallback;
  }

  function formatPricePair(form, regularCents, finalCents) {
    var regular = getNumericCents(regularCents, finalCents);
    var final = getNumericCents(finalCents, 0);
    if (regular > final) {
      return '<small class="um-cart-addon-compare">' + renderMoney(form, regular) + '</small><span class="um-cart-addon-sale">' + renderMoney(form, final) + '</span>';
    }
    return renderMoney(form, final);
  }

  function getPriceDetailsAddonLabel(childEntry) {
    var entry = childEntry && childEntry.entry ? childEntry.entry : null;
    var mappedHandle = handleize(entry && entry.productHandle ? entry.productHandle : '');
    var childHandle = handleize(childEntry && childEntry.item && childEntry.item.handle ? childEntry.item.handle : '');
    var effectiveHandle = mappedHandle || childHandle;

    if (effectiveHandle === 'customisation-pop-art-text') {
      return 'Pop art text';
    }

    return (childEntry && childEntry.label) ? childEntry.label : 'Add-on';
  }

  function summarizeDiscountTitles(items) {
    var byTitle = {};
    var topTitle = '';
    var topAmount = 0;

    (items || []).forEach(function(item) {
      // Prefer explicit rendered discount titles when available (e.g. "Buy 2, Save 20%").
      (item.discount_titles || []).forEach(function(title) {
        var normalizedTitle = String(title || '').trim();
        if (!normalizedTitle) return;
        if (!byTitle[normalizedTitle]) byTitle[normalizedTitle] = 0;
      });

      (item.line_level_discount_allocations || []).forEach(function(allocation) {
        var title = allocation && allocation.discount_application ? String(allocation.discount_application.title || '').trim() : '';
        var amount = getNumericCents(allocation && allocation.amount, 0);
        if (!title || amount <= 0) return;
        byTitle[title] = (byTitle[title] || 0) + amount;
      });
    });

    Object.keys(byTitle).forEach(function(title) {
      if (byTitle[title] >= topAmount) {
        topAmount = byTitle[title];
        topTitle = title;
      }
    });

    return {
      titles: Object.keys(byTitle),
      topTitle: topTitle
    };
  }

  function buildPriceDetailsMarkup(parentItem, childEntries, form, totals, discountSummary) {
    var detailRows = [];
    var parentMeta = getLinePriceMeta(parentItem);

    detailRows.push(
      '<div class="um-cart-price-details-row"><span class="um-cart-price-details-label">' + escapeHtml(getCartString('cartConfiguredItemLabel', 'Configured item')) + '</span><span class="um-cart-price-details-value">' +
      formatPricePair(form, parentMeta.regularCents, parentMeta.finalCents) +
      '</span></div>'
    );

    (childEntries || []).forEach(function(childEntry) {
      var childMeta = getLinePriceMeta(childEntry.item);
      var detailsLabel = getPriceDetailsAddonLabel(childEntry);
      detailRows.push(
        '<div class="um-cart-price-details-row"><span class="um-cart-price-details-label">' + escapeHtml(detailsLabel) + '</span><span class="um-cart-price-details-value">' +
        formatPricePair(form, childMeta.regularCents, childMeta.finalCents) +
        '</span></div>'
      );
    });

    detailRows.push(
      '<div class="um-cart-price-details-row um-cart-price-details-row--total"><span class="um-cart-price-details-label">' + escapeHtml(getCartString('cartTotalLabel', 'Total')) + '</span><span class="um-cart-price-details-value">' +
      renderMoney(form, totals.finalCents) +
      '</span></div>'
    );

    var appliedDiscountName = '';
    if (discountSummary && discountSummary.topTitle) {
      appliedDiscountName = String(discountSummary.topTitle).trim();
    } else if (discountSummary && Array.isArray(discountSummary.titles) && discountSummary.titles.length) {
      appliedDiscountName = String(discountSummary.titles[0]).trim();
    }
    if (appliedDiscountName) {
      detailRows.push(
        '<div class="um-cart-price-details-row um-cart-price-details-row--discount"><span class="um-cart-price-details-label">' +
        escapeHtml(appliedDiscountName + ' - ' + getCartString('cartAppliedLabel', 'applied')) +
        '</span><span class="um-cart-price-details-value"></span></div>'
      );
    }

    return detailRows.join('');
  }

  function applyCombinedPricing(parentNode, parentItem, childEntries, form, groupCount) {
    if (!parentNode || !parentItem || !form) return;

    var priceCol = parentNode.querySelector('.cart__item-price-col');
    if (!priceCol) return;

    Array.from(priceCol.children).forEach(function(child) {
      if (child.classList.contains('um-cart-combined-pricing')) return;
      child.classList.add('um-cart-legacy-price');
      child.style.display = 'none';
    });

    var allItems = [parentItem].concat((childEntries || []).map(function(entry) { return entry.item; }));
    var totals = { regularCents: 0, finalCents: 0, savingsCents: 0 };
    allItems.forEach(function(item) {
      var meta = getLinePriceMeta(item);
      totals.regularCents += meta.regularCents;
      totals.finalCents += meta.finalCents;
      totals.savingsCents += meta.savingsCents;
    });

    var discountSummary = summarizeDiscountTitles(allItems);
    var offerLabel = '';
    if (totals.savingsCents > 0) {
      var strings = window.theme && theme.strings ? theme.strings : {};
      offerLabel = groupCount > 1
        ? (strings.cartTotalSavingsLabel || 'Total savings')
        : (strings.cartYouSavedLabel || 'You saved');

      var discountTitle = getSingleActiveDiscountTitle(form, { items: allItems });
      if (discountTitle) {
        offerLabel += ' (' + discountTitle + ')';
      }
    }

    var paidLineItemCount = 0;
    var hasCompareAtSavings = false;
    var hasDiscountAllocationSavings = false;
    allItems.forEach(function(item) {
      var meta = getLinePriceMeta(item);
      if (meta.finalCents > 0) paidLineItemCount += 1;

      var compareCents = getNumericCents(item && item.compare_line_price, 0);
      if (compareCents > meta.finalCents) {
        hasCompareAtSavings = true;
      }

      var hasLineDiscountAllocation =
        (Array.isArray(item && item.line_level_discount_allocations) && item.line_level_discount_allocations.length > 0) ||
        (Array.isArray(item && item.discount_titles) && item.discount_titles.length > 0);
      if (hasLineDiscountAllocation) {
        hasDiscountAllocationSavings = true;
      }
    });
    var hasMultipleDiscountTypes = hasCompareAtSavings && hasDiscountAllocationSavings;
    var showPriceDetails = false;

    var block = document.createElement('div');
    block.className = 'um-cart-combined-pricing notranslate';
    block.setAttribute('translate', 'no');
    block.setAttribute('data-langshop-ignore', 'true');
    block.innerHTML = [
      '<div class="um-cart-combined-total">' + renderMoney(form, totals.finalCents) + '</div>',
      totals.savingsCents > 0 ? '<div class="um-cart-combined-offer"><span class="um-cart-combined-offer-label">' + escapeHtml(offerLabel) + '</span><span class="um-cart-combined-offer-amount">' + renderMoney(form, totals.savingsCents) + '</span></div>' : '',
      showPriceDetails ? '<button type="button" class="um-cart-price-details-toggle" aria-expanded="false">' + escapeHtml(getCartString('cartPriceDetailsLabel', 'Price details')) + '</button>' : '',
      showPriceDetails ? '<div class="um-cart-price-details" hidden>' + buildPriceDetailsMarkup(parentItem, childEntries, form, totals, discountSummary) + '</div>' : ''
    ].join('');

    var combinedTotalEl = block.querySelector('.um-cart-combined-total');
    var subtotalSample = form && form.form ? form.form.querySelector('[data-subtotal]') : null;
    if (combinedTotalEl && subtotalSample && window.getComputedStyle) {
      var sampleStyles = window.getComputedStyle(subtotalSample);
      combinedTotalEl.style.fontSize = sampleStyles.fontSize;
      combinedTotalEl.style.fontWeight = sampleStyles.fontWeight;
      combinedTotalEl.style.lineHeight = sampleStyles.lineHeight;
      combinedTotalEl.style.letterSpacing = sampleStyles.letterSpacing;
      combinedTotalEl.style.fontFamily = sampleStyles.fontFamily;
      combinedTotalEl.style.color = sampleStyles.color;
    }

    var toggle = block.querySelector('.um-cart-price-details-toggle');
    var details = block.querySelector('.um-cart-price-details');
    if (toggle && details) {
      toggle.addEventListener('click', function() {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var cartItem = block.closest('.cart__item');

        // Close any other open details panels first to avoid overlapping
        // stacking-context conflicts inside the drawer.
        var openToggles = form.products
          ? form.products.querySelectorAll('.um-cart-price-details-toggle[aria-expanded="true"]')
          : [];
        Array.prototype.forEach.call(openToggles, function(otherToggle) {
          if (otherToggle === toggle) return;
          otherToggle.setAttribute('aria-expanded', 'false');
          var otherDetails = otherToggle.parentNode && otherToggle.parentNode.querySelector
            ? otherToggle.parentNode.querySelector('.um-cart-price-details')
            : null;
          if (otherDetails) otherDetails.hidden = true;
          var otherItem = otherToggle.closest ? otherToggle.closest('.cart__item') : null;
          if (otherItem) otherItem.classList.remove('um-price-details-open');
        });

        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        details.hidden = expanded;
        if (cartItem) {
          cartItem.classList.toggle('um-price-details-open', !expanded);
        }
      });
    }

    priceCol.appendChild(block);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function setWrapperEmptyState(form, cart) {
    if (!form || !form.wrapper || !cart) return;
    if (cart.item_count > 0) {
      form.wrapper.classList.remove('is-empty');
    } else {
      form.wrapper.classList.add('is-empty');
    }
  }

  function getItemsFromRenderedMarkup(form) {
    if (!form || !form.products) return [];

    var nodes = form.products.querySelectorAll('.cart__item[data-key]');
    var items = [];

    nodes.forEach(function(node) {
      var productLink = node.querySelector('.cart__item-name[href], .cart__image a[href]');
      var href = productLink ? String(productLink.getAttribute('href') || '') : '';
      var hrefMatch = href.match(/\/products\/([^?\/]+)/);
      var fallbackHandle = hrefMatch && hrefMatch[1] ? hrefMatch[1] : '';

      var loox = node.querySelector('.loox-rating[data-id]');
      var fallbackProductId = loox ? String(loox.getAttribute('data-id') || '') : '';

      var qtyInput = node.querySelector('.js-qty__num');
      var quantity = parseInt(
        node.getAttribute('data-quantity') ||
        (qtyInput ? qtyInput.value : '0') ||
        '0',
        10
      );

      var finalLinePrice = parseInt(node.getAttribute('data-final-line-price') || '0', 10);
      var originalLinePrice = parseInt(node.getAttribute('data-original-line-price') || '0', 10);
      var compareLinePrice = parseInt(node.getAttribute('data-compare-line-price') || '0', 10);
      var lineDiscounts = parseJsonSafe(node.getAttribute('data-line-discounts') || '[]', []);
      var discountTitles = [];
      node.querySelectorAll('.cart__item-price-col small.cart__discount').forEach(function(discountEl) {
        var rawText = String(discountEl.textContent || '').trim();
        if (!rawText) return;
        // Example: "Buy 2, Save 20% (-Â£25)" -> "Buy 2, Save 20%"
        var cleaned = rawText.replace(/\s*\(-.*$/, '').trim();
        if (!cleaned) return;
        if (discountTitles.indexOf(cleaned) === -1) discountTitles.push(cleaned);
      });
      var properties = normalizeProperties(parseJsonSafe(node.getAttribute('data-properties') || '{}', {}));
      if (!properties || typeof properties !== 'object' || Object.keys(properties).length === 0) {
        properties = {};
        node.querySelectorAll('.custom_properties').forEach(function(propEl) {
          var strong = propEl.querySelector('strong');
          if (!strong) return;
          var key = String(strong.textContent || '').replace(/:\s*$/, '').trim();
          if (!key) return;
          var value = String(propEl.textContent || '').replace(String(strong.textContent || ''), '').trim();
          if (!value) return;
          properties[key] = value;
        });
      }

      var nameEl = node.querySelector('.cart__item-name-title');
      var fallbackTitle = nameEl ? String(nameEl.textContent || '').trim() : '';

      items.push({
        key: node.getAttribute('data-key') || '',
        handle: node.getAttribute('data-product-handle') || fallbackHandle,
        product_id: node.getAttribute('data-product-id') || fallbackProductId,
        product_title: node.getAttribute('data-product-title') || fallbackTitle,
        quantity: Number.isFinite(quantity) ? quantity : 0,
        final_line_price: Number.isFinite(finalLinePrice) ? finalLinePrice : 0,
        original_line_price: Number.isFinite(originalLinePrice) ? originalLinePrice : 0,
        compare_line_price: Number.isFinite(compareLinePrice) ? compareLinePrice : 0,
        line_level_discount_allocations: Array.isArray(lineDiscounts) ? lineDiscounts : [],
        discount_titles: discountTitles,
        properties: properties && typeof properties === 'object' ? properties : {}
      });
    });

    return items;
  }

  function dispatchCartUpdated(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: cart
      }
    }));
  }

  function hideCartRowsByKeys(form, keys) {
    if (!form || !form.products || !Array.isArray(keys)) return;
    keys.forEach(function(key) {
      if (!key) return;
      var row = form.products.querySelector('.cart__item[data-key="' + escapeSelectorValue(key) + '"]');
      if (!row) return;
      row.classList.add('um-cart-item--child');
      row.style.display = 'none';
    });
  }

  function applyChangeList(changes) {
    var queue = changes.slice();
    var lastCart = null;

    return queue.reduce(function(chain, change) {
      return chain.then(function() {
        return theme.cart.changeItem(change.key, change.quantity).then(function(cart) {
          lastCart = cart;
          return cart;
        });
      });
    }, Promise.resolve()).then(function() {
      return lastCart || theme.cart.getCart();
    });
  }

  function ensureScopedStyles() {
    if (document.getElementById(EXPERIMENT_NAMESPACE + '-styles')) return;
    var style = document.createElement('style');
    style.id = EXPERIMENT_NAMESPACE + '-styles';
    style.textContent = [
      '.um-cart-summary-lines{margin-top:6px;}',
      '.um-cart-summary-line{font-size:13px;line-height:1.35;color:#4f4942;}',
      '.um-cart-summary-line + .um-cart-summary-line{margin-top:2px;}',
      '.um-cart-summary-line--base{font-size:14px;font-weight:500;color:#3f3932;}',
      '.um-cart-summary-line--addons{color:#5f564c;}',
      '.um-cart-summary-line--linked{margin-top:10px;padding-left:0;}',
      '.um-cart-summary-link-item{padding:2px 0;}',
      '.um-cart-summary-link-item + .um-cart-summary-link-item{margin-top:0;}',
      '.um-cart-summary-link-row{display:grid;grid-template-columns:minmax(0,1fr) auto auto;align-items:center;column-gap:10px;}',
      '.um-cart-summary-link-subrow{font-size:12px;line-height:1.35;color:#5f564c;margin:3px 0 0 2px;}',
      '.um-cart-summary-link-subrow + .um-cart-summary-link-subrow{margin-top:2px;}',
      '.um-cart-summary-link-price{font-size:13px;font-weight:400;color:#4f4942;white-space:nowrap;display:inline-flex;align-items:center;gap:6px;}',
      '.um-cart-summary-link-price .um-cart-addon-compare{font-size:13px;opacity:1;color:#4f4942;}',
      '.um-cart-summary-link-price .um-cart-addon-sale{font-size:13px;font-weight:400;color:#4f4942;}',
      '.um-cart-summary-link-remove-spacer{display:inline-block;width:40px;}',
      '.um-cart-linked-remove{justify-self:end;border:0;background:transparent;color:#8a857f;cursor:pointer;font-size:12px;line-height:1.2;padding:4px 2px;text-decoration:underline;text-underline-offset:2px;font-weight:400;text-transform:lowercase;}',
      '.um-cart-linked-remove:hover{color:#6f6962;}',
      '.um-cart-linked-remove:disabled{opacity:0.5;cursor:default;}',
      '.um-cart-summary-token--abbrev{font-weight:600;text-shadow:0 0 6px rgba(255,214,153,0.42);}',
      '.um-cart-summary-token-main{font-weight:700;color:#3f3932;}',
      '.um-cart-summary-token-tail{font-weight:400;color:#4f4942;}',
      '.um-cart-summary-compact{display:block;}',
      '.um-cart-summary-desktop{display:none;}',
      '.um-cart-summary-desktop-item{padding:2px 0;}',
      '.um-cart-summary-desktop-item + .um-cart-summary-desktop-item{margin-top:0;}',
      '.um-cart-summary-desktop-row{display:flex;align-items:flex-start;justify-content:space-between;gap:10px;}',
      '.um-cart-summary-desktop-row + .um-cart-summary-desktop-row{margin-top:4px;}',
      '.um-cart-summary-desktop-main{flex:1 1 auto;min-width:0;font-size:13px;line-height:1.38;color:#4f4942;}',
      '.um-cart-summary-desktop-label{font-weight:700;color:#3f3932;}',
      '.um-cart-summary-desktop-value{font-weight:400;color:#4f4942;}',
      '.um-cart-summary-token-plain{font-weight:400;color:#4f4942;}',
      '.um-cart-summary-desktop-subrow{font-size:12px;line-height:1.35;color:#5f564c;padding-left:2px;margin-top:3px;}',
      '.um-cart-summary-desktop-subrow + .um-cart-summary-desktop-subrow{margin-top:2px;}',
      '.um-cart-summary-subrow-label{font-weight:600;color:#4f4942;}',
      '.um-cart-summary-subrow-value{font-weight:400;color:#5f564c;}',
      '.um-cart-summary-desktop-actions{display:inline-flex;align-items:center;gap:8px;white-space:nowrap;}',
      '.um-cart-kv-key{font-weight:700;color:#3f3932;}',
      '.um-cart-kv-value{font-weight:400;color:#4f4942;}',
      '.um-cart-kv-link{font-weight:400;color:#3f3932;text-decoration:underline;text-underline-offset:2px;}',
      '.um-cart-kv-link:hover{color:#2f2a24;}',
      '.um-cart-summary-sep{opacity:0.82;padding:0 1px;}',
      '#CartDrawer .drawer__scrollable{position:relative;}',
      '#CartDrawer .drawer__scrollable [data-products]{position:relative;z-index:2000;}',
      '#CartDrawer .drawer__scrollable [data-products],#CartDrawer .drawer__scrollable [data-products] .cart__items{margin-top:0 !important;padding-top:0 !important;}',
      '#CartDrawer .drawer__scrollable [data-products] .cart__items{border-top:1px solid var(--colorBorder) !important;padding-top:10px !important;}',
      '#CartDrawer .drawer__scrollable [data-products] .cart__items > .cart__item:first-child{margin-top:0 !important;padding-top:0 !important;border-top:0 !important;}',
      '#CartDrawer .cart__items > .cart__item[style*="display: none"] + .cart__item{margin-top:0 !important;padding-top:0 !important;border-top:0 !important;}',
      '#CartDrawer .cart__items > .cart__item.um-cart-first-visible{margin-top:0 !important;padding-top:0 !important;border-top:0 !important;}',
      '#CartDrawer .cart-drawer-notes{position:relative;z-index:1;}',
      '.um-cart-addon-content-list{margin-top:6px;}',
      '.um-cart-addon-content-row{font-size:13px;line-height:1.35;color:#4f4942;}',
      '.um-cart-addon-content-row + .um-cart-addon-content-row{margin-top:6px;}',
      '.um-cart-unconnected-props{margin-top:6px;padding-top:0;}',
      '.um-cart-unconnected-prop-row{font-size:12px;line-height:1.35;color:#6b6760;}',
      '.um-cart-unconnected-prop-row + .um-cart-unconnected-prop-row{margin-top:6px;}',
      '.um-cart-combined-pricing{display:flex;flex-direction:column;align-items:flex-end;gap:4px;position:relative;z-index:1300;margin-top:8px;}',
      '.cart__item.um-price-details-open{position:relative;z-index:1400;}',
      '.um-cart-combined-total{line-height:1.05;}',
      '.um-cart-combined-offer{display:flex;gap:6px;align-items:center;color:#4f4942;font-size:13px;line-height:1.25;}',
      '.um-cart-combined-offer-label{font-weight:400;color:#4f4942;}',
      '.um-cart-combined-offer-amount{font-weight:500;color:#8b7575;}',
      '.um-cart-price-details-toggle{padding:0;border:0;background:none;color:#5f564c;font-size:12px;text-decoration:underline;cursor:pointer;}',
      '.um-cart-price-details{position:absolute;right:0;top:calc(100% + 6px);z-index:9999;background:#fff;padding:10px 12px;border:1px solid rgba(0,0,0,0.12);border-radius:4px;box-shadow:0 8px 24px rgba(0,0,0,0.12);width:min(320px,calc(100vw - 32px));max-width:calc(100vw - 32px);box-sizing:border-box;overflow-wrap:anywhere;}',
      '.um-cart-price-details-row{display:flex;justify-content:space-between;gap:12px;font-size:12px;line-height:1.4;color:#5f564c;min-width:0;}',
      '.um-cart-price-details-row + .um-cart-price-details-row{margin-top:3px;}',
      '.um-cart-price-details-label{text-align:left;flex:1 1 auto;min-width:0;overflow-wrap:break-word;word-break:normal;}',
      '.um-cart-price-details-value{white-space:nowrap;display:inline-flex;align-items:center;gap:6px;}',
      '.um-cart-price-details-row--savings .um-cart-price-details-label{color:#4f4942;font-weight:400;}',
      '.um-cart-price-details-row--savings .um-cart-price-details-value{color:#8b7575;font-weight:500;}',
      '.um-cart-price-details-row--total{margin-top:6px;padding-top:6px;border-top:1px solid rgba(0,0,0,0.08);font-weight:600;color:#1f1f1f;}',
      '.um-cart-addon-compare{text-decoration:line-through;opacity:0.7;font-size:12px;}',
      '.um-cart-addon-sale{font-weight:600;}',
      '@media (min-width:769px){#CartDrawer .drawer__scrollable{margin-top:-4px !important;}}',
      '@media (min-width:750px){.um-cart-summary-compact{display:none;}.um-cart-summary-desktop{display:block;margin-top:6px;}.um-cart-summary-desktop-row .um-cart-linked-remove{padding:0 2px;font-size:12px;line-height:1.25;}.um-cart-summary-desktop-item + .um-cart-summary-desktop-item{margin-top:4px;}.um-cart-summary-desktop-row--size + .um-cart-summary-desktop-item,.um-cart-summary-desktop-row--finish + .um-cart-summary-desktop-item{margin-top:6px;}}',
      '@media (max-width:749px){.um-cart-combined-pricing{max-width:100%;margin-top:6px;}.um-cart-price-details{width:min(300px,calc(100vw - 20px));max-width:calc(100vw - 20px);right:0;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function bindFormRemoveInterception(form) {
    // Native Shopify nested cart lines now handle parent/child remove behavior.
    // Disable legacy custom cascade-remove interception to avoid double handling.
    return;

    if (!form || !form.form || form.__umRemoveInterceptorBound) return;
    form.__umRemoveInterceptorBound = true;

    form.form.addEventListener('click', function(event) {
      var link = event.target && event.target.closest ? event.target.closest('.cart__remove a') : null;
      if (!link || !form.form.contains(link)) return;
      if (form.__umBundleDisabled) return;
      if (!form.__umBundleState) return;

      var lineItem = link.closest('.cart__item');
      var key = lineItem ? lineItem.getAttribute('data-key') : '';
      if (!key) return;

      var state = form.__umBundleState;
      var parentKey = state.parentByChild[key];
      if (parentKey) {
        event.preventDefault();
        event.stopPropagation();
        form.buildCart();
        return;
      }

      var childKeys = state.childrenByParent[key] || [];
      if (!childKeys.length) return;

      event.preventDefault();
      event.stopPropagation();

      var changes = [{ key: key, quantity: 0 }];
      childKeys.forEach(function(childKey) {
        changes.push({ key: childKey, quantity: 0 });
      });
      hideCartRowsByKeys(form, [key].concat(childKeys));

      applyChangeList(changes)
        .then(function(cart) {
          setWrapperEmptyState(form, cart);
          form.buildCart();
          dispatchCartUpdated(cart);
        })
        .catch(function(error) {
          logWarn('Cascade remove failed, falling back to legacy remove path.', error);
          window.location.href = link.getAttribute('href');
        });
    });
  }

  function bindProductFormTokens() {
    function setTokenOnForm(form) {
      if (!form) return;
      var hidden = form.querySelector('input[name="properties[_um_bundle_token]"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'properties[_um_bundle_token]';
        form.appendChild(hidden);
      }
      hidden.value = String(Date.now()) + '-' + Math.random().toString(36).slice(2, 10);
    }

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form) {
      setTokenOnForm(form);
    });

    document.addEventListener('submit', function(event) {
      var form = event.target && event.target.closest ? event.target.closest('form[action*="/cart/add"]') : null;
      if (!form) return;
      setTokenOnForm(form);
    });
  }

  function initializePatch() {
    if (hasPatched) return;
    if (!theme.CartForm || !theme.CartForm.prototype) return;

    var mapping = normalizeAddonConfig(readAddonConfig());
    var signatureIndex = buildAddonSignatureIndex(mapping);
    if (!signatureIndex.handles.size && !signatureIndex.ids.size) {
      logWarn('No valid add-on mapping found. Experiment disabled.');
      return;
    }

    ensureScopedStyles();
    bindProductFormTokens();

    var proto = theme.CartForm.prototype;
    var originalInit = proto.init;
    var originalCartMarkup = proto.cartMarkup;
    var originalQuantityChanged = proto.quantityChanged;
    var runBundleRefresh = function(instance, options) {
      if (!instance || instance.__umBundleDisabled) return;
      if (isLegacyModeActive()) {
        cleanupExperimentMarkup(instance);
        instance.__umBundleState = null;
        return;
      }
      var refreshOptions = options || {};

      try {
        var renderedItems = getItemsFromRenderedMarkup(instance);
        var cart = {
          items: renderedItems,
          item_count: renderedItems.reduce(function(sum, item) {
            return sum + Number(item.quantity || 0);
          }, 0)
        };

        var state = buildBundleState(cart, mapping, signatureIndex);
        instance.__umBundleState = state;

        if (state.orphanKeys.length > 0 && state.explicitLinkDetected && !refreshOptions.skipMutations) {
          if (instance.__umOrphanCleanupInFlight) return;
          instance.__umOrphanCleanupInFlight = true;
          hideCartRowsByKeys(instance, state.orphanKeys);

          var orphanChanges = state.orphanKeys.map(function(key) {
            return { key: key, quantity: 0 };
          });

          applyChangeList(orphanChanges)
            .then(function() {
              instance.__umOrphanCleanupInFlight = false;
              instance.buildCart();
            })
            .catch(function(error) {
              instance.__umOrphanCleanupInFlight = false;
              instance.__umBundleDisabled = true;
              instance.__umBundleState = null;
              cleanupExperimentMarkup(instance);
              logWarn('Orphan cleanup failed. Experiment disabled for this cart instance.', error);
            });
          return;
        }

        applyExperimentMarkup(instance, state);
        instance.updateCount(state.parentCount);
      } catch (error) {
        instance.__umBundleDisabled = true;
        instance.__umBundleState = null;
        cleanupExperimentMarkup(instance);
        logWarn('Grouping failed. Falling open to legacy cart behavior.', error);
      }
    };

    proto.init = function() {
      originalInit.apply(this, arguments);
      bindFormRemoveInterception(this);
      window.setTimeout(function() {
        runBundleRefresh(this);
      }.bind(this), 0);
    };

    proto.cartMarkup = function() {
      originalCartMarkup.apply(this, arguments);

      runBundleRefresh(this);
    };

    proto.quantityChanged = function(evt) {
      var originalArgs = arguments;

      if (this.__umBundleDisabled || !this.__umBundleState) {
        return originalQuantityChanged.apply(this, originalArgs);
      }

      var key = evt && evt.detail ? evt.detail[0] : '';
      var qty = evt && evt.detail ? evt.detail[1] : null;
      var el = evt && evt.detail ? evt.detail[2] : null;

      if (!key || qty == null) {
        return originalQuantityChanged.apply(this, originalArgs);
      }

      var state = this.__umBundleState;
      if (state.parentByChild[key]) {
        if (el) el.classList.remove('is-loading');
        this.buildCart();
        return;
      }

      var childKeys = state.childrenByParent[key] || [];
      if (!childKeys.length) {
        return originalQuantityChanged.apply(this, originalArgs);
      }

      if (el) {
        el.classList.add('is-loading');
      }

      var changes = [{ key: key, quantity: qty }];
      childKeys.forEach(function(childKey) {
        changes.push({ key: childKey, quantity: qty });
      });

      applyChangeList(changes)
        .then(function(cart) {
          setWrapperEmptyState(this, cart);
          this.buildCart();
          dispatchCartUpdated(cart);
        }.bind(this))
        .catch(function(error) {
          this.__umBundleDisabled = true;
          this.__umBundleState = null;
        cleanupExperimentMarkup(this);
        logWarn('Quantity cascade failed. Delegating back to legacy flow.', error);
        originalQuantityChanged.apply(this, originalArgs);
      }.bind(this));
    };

    function buildStandaloneInstance(formEl, location) {
      if (!formEl) return null;
      var productsEl = formEl.querySelector('[data-products]');
      if (!productsEl) return null;
      var moneyFormat = formEl.dataset.moneyFormat || theme.settings.moneyFormat;
      var stripTrailingZeros = formEl.dataset.stripTrailingZeros === 'true';
      return {
        form: formEl,
        products: productsEl,
        wrapper: formEl.parentNode,
        location: location || 'page',
        buildCart: function() {},
        updateCount: function() {},
        formatCartMoney: function(cents) {
          var formatted = theme.Currency.formatMoney(cents, moneyFormat);
          if (!stripTrailingZeros) {
            return formatted;
          }
          return String(formatted)
            .replace(/(\d)[\.,]00(\D|$)/, '$1$2')
            .replace(/<\/sup>\.00(\D|$)/, '</sup>$1');
        }
      };
    }

    function runStandaloneCartPageRefresh() {
      if (!document.body.classList.contains('template-cart')) return;

      var formEl = document.getElementById('CartPageForm');
      var standaloneInstance = buildStandaloneInstance(formEl, 'page');
      if (!standaloneInstance) return;

      runBundleRefresh(standaloneInstance, { skipMutations: true });
    }

    function runStandaloneDrawerRefresh() {
      if (!theme.settings || theme.settings.cartType !== 'drawer') return;

      var formEl = document.getElementById('CartDrawerForm');
      var standaloneInstance = buildStandaloneInstance(formEl, 'drawer');
      if (!standaloneInstance) return;

      runBundleRefresh(standaloneInstance, { skipMutations: true });
    }

    function scheduleStandaloneCartPasses() {
      if (!document.body.classList.contains('template-cart')) return;
      window.setTimeout(runStandaloneCartPageRefresh, 60);
      window.setTimeout(runStandaloneCartPageRefresh, 350);
      window.setTimeout(runStandaloneCartPageRefresh, 1200);
    }

    function scheduleStandaloneDrawerPasses() {
      if (!theme.settings || theme.settings.cartType !== 'drawer') return;
      window.setTimeout(runStandaloneDrawerRefresh, 80);
      window.setTimeout(runStandaloneDrawerRefresh, 350);
      window.setTimeout(runStandaloneDrawerRefresh, 1200);
    }

    hasPatched = true;

    scheduleStandaloneCartPasses();
    scheduleStandaloneDrawerPasses();
    document.addEventListener('page:loaded', scheduleStandaloneCartPasses);
    document.addEventListener('page:loaded', scheduleStandaloneDrawerPasses);
    document.addEventListener('drawerOpen.CartDrawer', scheduleStandaloneDrawerPasses);
    document.addEventListener('cart:updated', scheduleStandaloneDrawerPasses);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePatch);
  } else {
    initializePatch();
  }
})();
